var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showChart)?_c('Chart',{attrs:{"cdata":_vm.cdata}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }